var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"date-row"},[_c('div',[_c('div',{staticClass:"date-row__label"},[_vm._v(" "+_vm._s(_vm.$t('Tenders.Date'))+" ")]),_c('DateMenu',{attrs:{"value":_vm.valueMutable.fullDate,"with_allowed_dates":""},on:{"update:value":val => _vm.sendValues('date', val)}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }